import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  MainLayout,
  Header,
  Drawer,
  CustomRouter,
  Breadcrumbs,
  ComponentLoader,
  ToastContainer,
  getUserAccessRoutes,
} from "@techzyapp/ui-lib";
import { ChatBot } from "components";
import { useAuth } from "stores/auth";
import { getTokenFromLocalStorage } from "utils/helpers/auth";
import { authRoutes, allRoutes } from "routes";

import userSrc from "assets/images/user.png";
import logoSrc from "assets/images/logo.svg";

import "assets/css/styles.css";

const App = () => {
  const navigate = useNavigate();

  const { getUser, logout, stopUserLoading, user, getUserLoading } = useAuth();

  useEffect(() => {
    const token = getTokenFromLocalStorage();

    if (token) getUser().catch();
    else stopUserLoading();
  }, []);

  let routes = allRoutes;

  if (getUserLoading) {
    return <ComponentLoader componentType="page" />;
  } else {
    if (user?.accessKeys?.length)
      routes = getUserAccessRoutes(allRoutes, user.accessKeys);
  }

  return (
    <>
      {user ? (
        <>
          <MainLayout
            drawer={
              <Drawer
                routes={routes}
                logo={logoSrc}
                logoAltText="CocaCola"
                openFirstLevel
              />
            }
            header={
              <Header
                languages={false}
                user={{
                  name: "Welcome",
                  image: userSrc,
                  secondaryLabel: user.email,
                  menuItems: [
                    {
                      icon: "Lock",
                      label: "Change Password",
                      onClick: () => navigate(`/account`),
                    },
                  ],
                  onLogout: () => logout(),
                }}
              />
            }
            breadcrumbs={<Breadcrumbs routes={routes} />}
          >
            <CustomRouter routes={routes} />
          </MainLayout>
          {process.env.REACT_APP_ENABLE_CHATBOT === "true" &&
            user?.accessKeys?.includes("Analyst") && <ChatBot />}
        </>
      ) : (
        <>
          <CustomRouter routes={authRoutes} />
          <ToastContainer />
        </>
      )}
    </>
  );
};

export default App;
